<template>
  <div class="eu-pb_5">
    <div class="emd-container _highlight_header">
      <div class="emd-container__header">
        <h2 class="emd-text _size_default _type_caption">
          {{ $t('charge.detail.payer-details.title') }}
        </h2>
      </div>
      <div class="eu-pa_3 eu-mt_1">
        <div
          class="el-grid-list eu-mb_3"
          v-for="detailRow in transactionPayerTable"
          :key="`details-row-${detailRow[0].key}`"
        >
          <div
            v-for="detailCol in detailRow"
            :key="`details-col-${detailCol.key}`"
          >
            <p
              class="emd-text _color_default _type_caption eu-mb_1 details-col"
            >
              {{ $t(`charge.detail.payer-details.${detailCol.key}`) }}
            </p>
            <p class="`details-col-${ detailCol.key }-value`">
              {{ detailCol.value }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { splitEvery } from 'ramda'

export default {
  name: 'ChargesPayerDetails',
  props: {
    payer: {
      required: true,
      type: Object
    }
  },
  computed: {
    transactionPayerTable () {
      const {
        name,
        document,
        bank_account: { bank_name }
      } = this.payer

      const PAYER_DETAILS = {
        name,
        document,
        bank_name
      }

      return this.mountDetailColumns(PAYER_DETAILS)
    }
  },
  methods: {
    mountDetailColumns (payerDetails) {
      return splitEvery(
        3,
        Object.entries(payerDetails).map(([key, value]) => ({ key, value }))
      )
    }
  }
}
</script>
